import Avatar from 'components/Avatar';
import Button from 'components/Button';
import { ArrowRightIcon } from 'components/icons';
import Link from 'components/Link';
import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const SubBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

// Groups a title with its description so they stack tight (no gap between them);
// the surrounding block gap still separates the pair from the content below.
export const SubHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubTitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.3;
`;

export const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  line-height: 1.5;
`;

export const ConnectionsRow = styled.div`
  display: flex;
  gap: 1rem;
`;

export const ConnectionBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  background-color: ${({ theme }) => theme.colors.grey200};
  border-radius: 8px;
  padding: 1rem 0.5rem;
`;

export const ConnectionNumber = styled.span`
  color: ${({ theme }) => theme.colors.accent};
  font-size: 1.375rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.2;
  text-align: center;
`;

export const ConnectionLabel = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-size: 0.875rem;
  line-height: 1.3;
  text-align: center;
`;

export const NetworkList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;

  ${from.mobileXL`
    grid-template-columns: 1fr 1fr;
  `}
`;

export const NetworkItem = styled.li`
  border: 1px solid ${({ theme }) => theme.colors.grey200};
  border-radius: 8px;
`;

export const NetworkLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  text-decoration: none;

  &:hover {
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.grey200};
  }
`;

// The shared Avatar defaults to a 15rem profile-card size; constrain it to a
// compact thumbnail for the network list (scoped to this page only).
export const MemberAvatar = styled(Avatar)`
  && {
    width: 3rem;
    height: 3rem;
    margin: 0;
    flex-shrink: 0;
  }
`;

export const NetworkInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`;

export const NetworkName = styled.span`
  color: ${({ theme }) => theme.colors.accent};
  font-size: 0.75rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1;
`;

export const NetworkSummary = styled.span`
  color: ${({ theme }) => theme.colors.grey400};
  font-size: 0.75rem;
  line-height: 1.2;
`;

export const EmptyCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background-color: ${({ theme }) => theme.colors.grey200};
  border-radius: 8px;
  padding: 1.5rem 1rem;
`;

export const EmptyTitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.3;
`;

export const EmptyBody = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  line-height: 1.5;
`;

export const Footer = styled.div`
  display: flex;
`;

export const CommunityButton = styled(Button)`
  && {
    align-self: flex-start;
    align-items: center;
    width: fit-content;
    gap: 0.25rem;
    padding: 0.5rem 0.75rem;
  }
`;

export const ButtonArrow = styled(ArrowRightIcon)`
  width: 1.25rem;
  height: 1.25rem;
`;
